import {catchError, takeUntil} from 'rxjs/operators';
import {throwError as observableThrowError, Observable, Subscription, Subject} from 'rxjs';
import {HostListener, Injectable, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EventManager} from '@angular/platform-browser';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import 'rxjs/add/operator/filter';

@Injectable()

export class LotteriesService implements OnInit {
  headers: any;
  resizeSubscription: Subscription;
  orientationSubscription: Subscription;
  isMobile: boolean;
  isTablet: boolean;

  get onResize$(): Observable<Window> {
    return this.resizeSubject.asObservable();
  }

  get onResizeNew$(): Observable<Window> {
    return this.newResizeSubject.asObservable();
  }

  private resizeSubject: Subject<Window>;
  private newResizeSubject: Subject<Window>;
  public destroy: Subject<any>;

  constructor(private http: HttpClient, public eventManager: EventManager, private router: Router) {
    this.resizeSubject = new Subject();
    this.destroy = new Subject<any>();
    this.eventManager.addGlobalEventListener('window', 'resize', this.onResize.bind(this));
    this.resizeSubscription = this.onResize$
      .subscribe(size => {
        this.windowSizeCheck();
      });
    setTimeout(() => {
      this.windowSizeCheck();
    }, 500);
    this.newResizeSubject = new Subject();
    this.eventManager.addGlobalEventListener('window', 'DeviceOrientationEvent', this.onResizeNew.bind(this));
    this.orientationSubscription = this.onResizeNew$
      .subscribe(size => {
        this.windowSizeCheck();
      });
    setTimeout(() => {
      this.windowSizeCheck();
    }, 500);

    router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        this.eventManager.addGlobalEventListener('window', 'DeviceOrientationEvent', this.onResizeNew.bind(this));
      });
  }

  private onResize(event: UIEvent) {
    this.resizeSubject.next(<Window>event.target);
  }

  private onResizeNew(event: UIEvent) {
    this.newResizeSubject.next(<Window>event.target);
  }

  windowSizeCheck() {
    if (window.innerWidth < 768) {
      this.isMobile = true;
      this.isTablet = true;
    } else if (window.innerWidth < 992) {
      this.isMobile = false;
      this.isTablet = true;
    } else {
      this.isTablet = false;
      this.isMobile = false;
    }
  }

  ngOnInit() {
  }

  getLotteries(url: string): Observable<any> {
    return this.http
      .get(url).pipe(
        catchError(this.handleError), takeUntil(this.destroy));
  }

  postData(url: string, body: any): Observable<any> {
    return this.http
      .post(url, body,
        {headers: {'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9'}}).pipe(
        catchError(this.handleError), takeUntil(this.destroy));
  }

  postFiles(url: string, body: any): Observable<any> {
    return this.http
      .post(url, body).pipe(
        catchError(this.handleError), takeUntil(this.destroy));
  }

  private handleError(error: any) {
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg);
    return observableThrowError(errMsg);
  }

  getFormUrlEncoded(toConvert) {
    const formBody = [];
    for (const property of Object.keys(toConvert)) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(toConvert[property]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    return formBody.join('&');
  }

  toSendNoEmail(value) {
    let val = JSON.stringify(value);
    val = val
      .replace(/,/g, '&')
      .replace(/{/g, '')
      .replace(/}/g, '')
      .replace(/"/g, '')
      .replace(/ /g, '')
      .replace(/:/g, '=');
    return val;
  }

  contentDisplayer() {
    if (window.innerWidth < 768) {
      return true;
    } else {
      return false;
    }
  }


}
